import httpcommon3 from "./httpCommon3";

function toQueryString(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      usp.set(key, String(value));
    }
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const corporateApi = {
  getCorporateList: async (filterDetails = {}) => {
    const qs = toQueryString(filterDetails);
    const response = await httpcommon3.get(`/corporates${qs}`);
    return response.data;
  },

  saveCorporate: async (corporateData) => {
    const response = await httpcommon3.post("/corporates", corporateData);
    return response.data;
  },

  updateCorporate: async (id, formData) => {
    const response = await httpcommon3.put(`/corporates/${id}`, formData);
    return response.data;
  },

  approveCorporate: async (id, payload) => {
    const response = await httpcommon3.put(`/corporates/isApproved/${id}`, payload);
    return response.data;
  },

  getStateList: async () => {
    try {
      const response = await httpcommon3.get("/state/list");
      const d = response?.data;
      if (Array.isArray(d)) return d;
      if (Array.isArray(d?.data)) return d.data;
      if (Array.isArray(d?.content)) return d.content;
      return [];
    } catch {
      return [];
    }
  },

  getCorporateUsers: async (roleCode = "COORPERATE_MANAGER", page = 0, size = 50) => {
    try {
      const response = await httpcommon3.get("/onboarding-config/users", {
        params: { roleCode, page, size },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching corporate users:", error);
      return null;
    }
  },
};

export default corporateApi;
